'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fillInPatternBlob = fillInPatternBlob;
exports.fillPatternValue = fillPatternValue;

var _clone = require('../renderer/utils/clone');

var _tags = require('../tags');

var _consts = require('../consts');

function fillInPatternBlob(patternBlob, context) {
  var blob = (0, _clone.clone)(patternBlob);
  blob.tags = blob.tags.map(function (tag) {
    return _extends({}, tag, tag.props !== undefined ? { props: fillIn(tag.props, context, blob.tags) } : {}, tag.children !== undefined ? { children: fillPatternValue(tag.children, context, blob.tags) } : {});
  }).filter(function (tag) {
    return !tag.props || !tag.props.isEmptyTag;
  });
  return blob;
}

function fillPatternValue(value, context, tags) {
  var referencePath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (typeof value !== 'string') {
    return value;
  }

  var patterRegex = new RegExp(_consts.PATTERN_PREFIX + '.+?' + _consts.PATTERN_SUFFIX, 'g');
  return value.replace(patterRegex, function (placeholder) {
    if (placeholder.startsWith('' + _consts.SELF_REF_PATTERN_PREFIX) && !referencePath.some(function (item) {
      return item === placeholder;
    })) {
      referencePath.push(placeholder);
      var identifier = placeholder.replace('' + _consts.SELF_REF_PATTERN_PREFIX, '').replace('' + _consts.PATTERN_SUFFIX, '');
      var patternValue = (0, _tags.getValueByIdentifierFromContext)([{ tags: tags }], identifier, context, referencePath);
      patternValue = patternValue === undefined ? '' : patternValue;
      return patternValue;
    } else {
      var path = placeholder.replace('' + _consts.PATTERN_PREFIX, '').replace('' + _consts.PATTERN_SUFFIX, '');
      var contextValue = context && context[path] !== undefined ? context[path] : '';
      return typeof contextValue === 'string' ? contextValue : JSON.stringify(contextValue);
    }
  });
}

function fillIn(keyValue, context, tags) {
  return Object.keys(keyValue).reduce(function (acc, curr) {
    var value = keyValue[curr];
    if (typeof value === 'string') {
      acc[curr] = fillPatternValue(value, context, tags);
    } else {
      acc[curr] = value;
    }

    if (acc[curr] === '') {
      acc.isEmptyTag = true;
    }
    return acc;
  }, {});
}